<template>
    <ion-grid class="swipable">
        <ion-row class="content-row" align-items-center>
            <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                <ion-card>
                    <ion-card-header>
                        <ion-card-title text-left color="primary">{{ $t('components.alert-by.title') }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <ion-card v-for="destBy in destinationBy" v-bind:key="destBy.id" class="destination" @click="selectBy(destBy.by)">
                            <ion-item lines="none"><ion-thumbnail><ion-img :src="destBy.img"></ion-img></ion-thumbnail><ion-label>{{destBy.name}}</ion-label><ion-icon class="arrow" name="arrow-forward" mode="ios" size="small" slot="end"></ion-icon></ion-item>
                            <ion-card-content>{{destBy.note}}</ion-card-content>
                        </ion-card>
                        <div class="divider">{{ $t('components.alert-by.or') }}</div>
                        <ion-card class="destination anywhere" @click="selectAnywhere()">
                            <ion-item lines="none"><ion-thumbnail><ion-img :src="require('@/assets/by-icons/by-anywhere.svg')"></ion-img></ion-thumbnail><ion-label>{{ $t('components.alert-by.anywhere') }}</ion-label><ion-icon class="arrow" name="arrow-forward" mode="ios" size="small" slot="end"></ion-icon></ion-item>
                            <ion-card-content>{{ $t('components.alert-by.anywhere-note') }}</ion-card-content>
                        </ion-card>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
    import helpers from "@/helpers";

export default {
    name: 'AlertBy',
    data() {
        return {
            destinationBy: [
                {id: 1, name: 'Activity', by: 'activity', note: 'Skiing, trekking, partying...', img: require('@/assets/by-icons/by-activity.svg')},
                {id: 2, name: 'Popular regions', by: 'region', note: 'Caribbean, Europe, South America...', img: require('@/assets/by-icons/by-region.svg')},
                {id: 3, name: 'Popular cities', by: 'city', note: 'Barcelona, New York, Paris...', img: require('@/assets/by-icons/by-city.svg')},
            ],
            from_id: '---'
        }
    },
    mounted() {
        this.$Amplify.Auth.currentAuthenticatedUser().then(user => {
            const userDetails = helpers.getUserDetails(user);
            // bloody cognito... nasty checks
            if(!('custom:fromCityId' in userDetails) && ( userDetails['cognito:username'].startsWith('Facebook_') || userDetails['cognito:username'].startsWith('Google_'))) {
                this.$Amplify.Auth.userAttributes(user).then(res => {
                    // has gone through the initial setup
                    this.from_id = res.find(function (element) {
                        if (element['Name'] == 'custom:fromCityId')
                            return element['Value'];
                        else
                            return false;
                    });
                }).catch(err => {
                    this.$logger.debug('getUserAttributes', err);
                });
            } else {
                this.from_id = userDetails['custom:fromCityId'];
            }

            const progress = {
                step: 'to',
                value: userDetails['custom:fromCityId']
            };
            this.$AmplifyEventBus.$emit('addAlertProgress', progress);
        }).catch((error) => {
            this.$logger.debug('currentAuthenticatedUser', error);
            if (error.response && error.response.status === 401 || error == 'not authenticated') {
                this.$logger.debug('unauthorized');
            }
            //this.$router.push('/welcome');
            this.$logger.debug('catch auth');
        });
        //this.$AmplifyEventBus.$emit('addAlertProgress', {step: 'to', value: '...'});
    },
    methods: {
        selectBy: function(path) {
            this.$router.push({name: 'add-alert-' + path, params: {from_id: this.from_id} });
        },
        selectAnywhere: function() {
            this.$AmplifyEventBus.$emit('addAlertProgress', {step: 'dates', value: 'ANY'});
            this.$router.push({name: 'add-alert-date', params: {from_id: this.from_id, to_type: 4, to_id: 'ANY'} });
        },
    }
}
</script>

<style scoped>
    .destination {
        padding: 0;
        margin-bottom: 0;
    }

    .destination ion-item {
        --inner-padding-end: .5em;
        --padding-start: .5em;
        margin: 0;
        cursor: pointer;
    }

    .destination:hover {
        background-color: #ffccdd;
    }

    .destination:hover ion-card-content {
        color: #fff;
    }

    .destination ion-label {
        color: #666;
        font-size: 1em;
        margin: 0;
    }

    .destination ion-icon {
        margin: 0;
    }

    .destination ion-card-content {
        color: #999;
        padding: .25em;
        font-size: .9em;
        background: rgba(220,220,220,.3);
    }

    .destination .arrow {
        margin-left: .5em;
    }

    .anywhere {
        background-color: #efc;
        margin-bottom: 1em;
    }

    .anywhere ion-label {
        font-size: 1.2em;
    }

    .anywhere ion-thumbnail {
        height: 3em;
        width: 3em;
    }

    .anywhere ion-thumbnail ion-img {
        height: 3em;
    }

    .anywhere:hover {
        background-color: #ac8;
    }

    .divider {
        margin: .75em auto;
        font-weight: bold;
    }
</style>